import { PERCENT_OF_ALERTS, noResultsText } from 'utils/charts/constants';
import BlackThickLineIcon from 'assets/images/black-thick-line.svg';
import QuartzBlueThickLineIcon from 'assets/images/quartz-blue-thick-line.svg';

const portfolioRiskMismatchGraphic = {
    image: {
        type: 'image',
        style: {
            image: BlackThickLineIcon
        },
        cursor: 'default',
        bottom: '3.5%',
        top: '95.5%',
        left: '23%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Portfolio Risk Mismatch Alert',
            font: '12px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '26.5%'
    }
};

const concentrationRiskGraphic = {
    image: {
        type: 'image',
        style: {
            image: QuartzBlueThickLineIcon
        },
        cursor: 'default',
        top: '95.5%',
        bottom: '3.5%',
        left: '53%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Concentration Risk Alert',
            font: '12px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '56.5%'
    }
};

export const scenarioTwoNoResultTrendAnalysisChartOptions = () => {
    return {
        title: [
            {
                left: 'left',
                text: 'Trend Analysis',
                textStyle: {
                    color: '#244B60',
                    fontSize: '12px'
                }
            }
        ],
        xAxis: [
            {
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                }
            }
        ],
        yAxis: [
            {
                name: PERCENT_OF_ALERTS,
                nameLocation: 'center',
                nameTextStyle: {
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12
                },
                nameGap: 60,
                axisLabel: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                }
            }
        ],
        grid: {
            width: '370px',
            height: '250px',
            top: '90px',
            left: '15%'
        },
        graphic: [
            portfolioRiskMismatchGraphic.image,
            portfolioRiskMismatchGraphic.text,
            concentrationRiskGraphic.image,
            concentrationRiskGraphic.text,
            noResultsText
        ]
    };
};
